<template>
    <BModal ref="inviteModal" :title="$t('inviteModal.title')" centered no-close-on-backdrop header-variant="primary" modal-class="no-border-modal">
        <form class="modal-content" id="inviteModalForm" @submit.prevent="handleSubmit">
            <div class="text-center">
                <p>{{ $t('inviteModal.description') }}</p>
            </div>
            <div class="mb-2">
                <label class="form-label">{{ $t('common.email') }}</label>
                <input class="form-control" type="email" required :placeholder="$t('inviteModal.emailPlaceholder')" v-model="email">
            </div>
        </form>
        <template #footer="{ cancel }">
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('common.cancel') }}</button>
                <span v-if="errorMessage" class="custom-error-msg">{{ errorMessage }}</span>
                <button type="submit" class="btn btn-primary" form="inviteModalForm">{{ $t('common.submit') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { showToast } from '@/services/toast';
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
    name: 'InviteModal',
    components : {
        BModal
    },
    setup() {
        const userStore = useUserStore();
        const { t } = useI18n();
        const email = ref("");
        const inviteModal = ref(null);
        const errorMessage = ref("");

        const show = () => {
            email.value = "";
            errorMessage.value = "";
            inviteModal.value.show();
        };

        const hide = () => {
            inviteModal.value.hide();
        };

        const showError = (msg) => {
            errorMessage.value = msg;
        };

        const handleSubmit = async () => {
            try {
                await userStore.inviteMember(email.value);
                hide();
                showToast('success', t('inviteModal.inviteSent'));

            } catch(error) {
                showToast('error', error);
            }
        };

        return {
            handleSubmit,
            errorMessage,
            showError,
            inviteModal,
            email,
            show,
            hide,
        };
    },
}
</script>

<style>
.no-border-modal .modal-header {
  border-bottom: none !important;
}

.no-border-modal .modal-footer {
  border-top: none !important;
}
</style>
